<template>
  <b-sidebar
    v-model="modalOpen"
    v-if="modalOpen"
    centered
    id="branchModal"
    class="edit-modal"
    width="500px"
    backdrop
    no-close-on-backdrop
    no-close-on-esc
    no-header
    body-class="bg-white"
  >
  
    <div class="p-2">
      <validation-observer ref="branchValidation">
        <b-form @submit.prevent="onSubmit">
          <b-row>
            <b-col class="d-flex justify-content-between" cols="12">
              
              <h3> {{ mainTitle }} </h3>
              <feather-icon
                size="20"
                class="cursor-pointer"
                @click="modalOpen = false"
                icon="XIcon"
              />
            </b-col>
            <b-col cols="12">
              <hr />
            </b-col>
            
            <b-col cols="12">
              <form-select
                label="رقم و تاريخ اجتماع مجلس الإدارة الذي تم خلاله تحديد موعد اجتماع الهيئة العامة"
                v-model="form.meeting_minute_id"
                :getOptionLabel="(x) => x.meeting_minutes_label"
                :reduce="(x) => x"
                id="gov"
                ep="v2/selects/meeting-minutes"
                ref="gov"
                rules="required"
              />
              
              
              <small class="text-secondary mb-1 d-block" style="margin-top: -10px;">
                في حال عدم وجود محضر الاجتماع يُرجى تقديم معاملة بالمحضر الجديد
              </small>
            </b-col>
            
            <b-col cols="12">
              <form-mask
                options="date"
                placeholder="YYYY-MM-DD"
                style="height: 37.5px !important"
                v-model="form.first_meeting_date"
                label="موعد الإجتماع الأول"
                rules="required"
                class="w-25"
              />
              <small
                v-if="form.meeting_minute_id && checKdifferenceInTime(form.meeting_minute_id , form.first_meeting_date , 30)"
                class="text-danger"
                style="white-space: pre-line"
                >يجب أن يكون تاريخ الاجتماع الأول بفارق 30 يوم كحد أدنى عن تاريخ اليوم الحالي </small
              >
            </b-col>
            
            <b-col cols="12">
              <form-mask
                options="date"
                placeholder="YYYY-MM-DD"
                style="height: 37.5px !important"
                v-model="form.second_meeting_date"
                label="موعد الإجتماع الثاني"
                rules="required"
                class="w-25"
              />
              <small
                v-if="form.second_meeting_date && checKdifferenceInTime(form.first_meeting_date , form.second_meeting_date , 20)"
                class="text-danger"
                style="white-space: pre-line"
                >يجب أن يكون الفارق بين الإجتماعين 20 يوم على الأقل</small
              >
            </b-col>

            <b-col cols="12">
              <form-input
                label="مكان عقد الإجتماع"
                v-model="form.meeting_location"
                rules="required"
                
              />

            </b-col>

            <b-col cols="12">
              <form-input
                label="عدد أعضاء الهيئة العامة"
                v-model="form.general_authority_members_count"
                rules="required|integer"
                
              />

            </b-col>

            <b-col cols="12">
              <form-input
                label="عدد أعضاء الهيئة العامة الذي يحق لهم الحضور"
                v-model="form.general_authority_members_who_can_attend_count"
                rules="required|integer"
                
              />
              <small v-if="isNumberTrue" class="text-danger mb-1 d-block" style="margin-top: -10px;">
                يجب أن يكوم عدد أعضاء الهسئة العامة الذي يحق لهم الحضور غير مساوي للصفر و قيمته أصغر أو تساوي عدد أعضاء الهئية العامة 
              </small>

            </b-col>

            <b-col cols="12">
              <b-form-group label="جدول الأعمال" label-for="details" class="my-1">
                <validation-provider
                  #default="{ errors }"
                  name="جدول الأعمال"
                  rules="required"
                  id="details"
                  mode="passive"
                >
                  <quill-editor
                    :options="editorOption"
                    v-model="form.business_schedule"
                    :class="{ quillEditor: errors.length > 0 }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-checkbox
                id="remember-me"
                v-model="form.does_meeting_include_nomination_of_board_members"
                name="checkbox-1"
                v-if="isHasPublicBenefit"
              >
              هل تضمن جدول الأعمال انتخاب مجلس إدارة
              </b-form-checkbox>
            </b-col>

            <b-col cols="12" class="mt-2" v-if="form.does_meeting_include_nomination_of_board_members == true">
              <b-form-group label="أسماء المرشحين لعضوية مجلس الإدارة" label-for="details" class="my-1">
                <validation-provider
                  #default="{ errors }"
                  name="أسماء المرشحين لعضوية مجلس الإدارة"
                  rules="required"
                  id="details"
                  mode="passive"
                >
                  <quill-editor
                    :options="editorOption"
                    v-model="form.directors_board_candidates_membership_names"
                    :class="{ quillEditor: errors.length > 0 }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            
          </b-row>
          <hr />

          <b-row class="px-1 justify-content-end">
            <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
            <save-btn
              type="submit"
              variant="success"
              :loading="loading"
              :label="btnLabel"
            >
            </save-btn>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
    
  </b-sidebar>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormFile,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton,
  BSidebar,
  BFormCheckbox
} from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import formSelect from "@/components/form-select";
import formInput from "@/components/form-input";
import formTextarea from "@/components/form-textarea";
import saveBtn from "@/components/loader-btn";
import FormMask from "@/components/form-mask";
import { required, integer } from "@validations";
import mapSelect from "@/components/map-select";
import { ValidationProvider } from "vee-validate";
import FormImageInput from "@/components/FormImageInput.vue";
import { quillEditor } from "vue-quill-editor";
import FormFileInput from "@/components/FormFileInput.vue";
import "quill/dist/quill.snow.css";
import FormAutocomplete from "@/components/form-autocomplete";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { differenceInTime } from "@/utils/utils";

import authHelpers from "@/utils/auth-helpers";

const initForm = {};
export default {
  components: {
    formInput,
    formTextarea,
    formSelect,
    BButton,
    BSidebar,
    FormMask,
    saveBtn,
    BRow,
    BCol,
    mapSelect,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BFormFile,
    BForm,
    BFormRadio,
    BFormTextarea,
    ValidationObserver,
    ValidationProvider,
    FormImageInput , 
    quillEditor ,
    FormFileInput , 
    FormAutocomplete ,
    BFormCheckbox
  },
  props: {
    value: Boolean,
    title: String,
    mainTitle: {
      type: String,
      default: () => "بيانات معاملة",
    },
    btnLabel: String,
    loading: Boolean,
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
  },
  data() {
    return {
      temp : false ,
      form: {},
      required,
      integer,
      govId: null,
      mapModal: false,
      isNumberTrue : false ,
      isHasPublicBenefit: authHelpers.isHasPublicBenefit(),
      optionsType: [
        { value: 1, title: "مادية" },
        { value: 0, title: "عيني" },
      ],
      editorOption: {
        modules: {
          toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['link'],
          ]
        }
      },
    };
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
    branchTypes() {
      return this.$store.getters["branch-types/options"];
    },
    govEp() {
      return this.form.branch_type_id &&
        this.branchTypes.find((el) => el.id === this.form.branch_type_id)
          .name_ar === "مكتب"
        ? "v2/selects/branch-related-governorates?related=true"
        : "v2/selects/branch-related-governorates?related=false";
    },
  },
 

  watch: {
    modalOpen(val) {
      if (val)
        this.$nextTick(() => {
          // this.init(this.intializeForm);
        });
    },
    govId(val) {
      if (val) {
        this.$refs.branchRealEstates.refreshOptions(
          `v2/selects/real-estates?gid=${val}`
        );
        delete this.form.real_estate_id;
      }
    },
    govEp: {
      immediate: true,
      handler(val) {
        if (this.$refs.govs) this.$refs.govs.refreshOptions(val);
      },
    },
    form: {
      deep: true,
      handler(val) {
        console.log("form change" , this.form)
        if((parseInt(this.form.general_authority_members_who_can_attend_count)> parseInt(this.form.general_authority_members_count)) || (parseInt(this.form.general_authority_members_who_can_attend_count) == 0 )){
           this.isNumberTrue = true
        }
        else{ 
            this.isNumberTrue = false
        }
      
      },
    

    },
    
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
      if (form.governorate_id) {
        this.govId = form.governorate_id;
        this.form.real_estate_id = form.real_estate_id;
      }
    },
    async onSubmit() {
      await this.$refs.branchValidation.validate().then(async (success) => {
        if (success) {
          if(this.isHasPublicBenefit == false){
            this.form.does_meeting_include_nomination_of_board_members = false
          }
          if(this.isNumberTrue === false && this.checKdifferenceInTime(this.form.first_meeting_date , this.form.second_meeting_date , 20) === false && this.checKdifferenceInTime(this.form.meeting_minute_id , this.form.first_meeting_date , 30) === false){
            if(this.form.does_meeting_include_nomination_of_board_members == false){
              this.form.does_meeting_include_nomination_of_board_members = 0
            }
            else{
              this.form.does_meeting_include_nomination_of_board_members = 1
            }
            this.$emit("confirm", this.form);
          }
        }
      });
    },
    checKdifferenceInTime(fisrtData , secondData , difference){
      if(difference== 30){
        const today = new Date().toISOString().slice(0, 10);
          return differenceInTime(today ,secondData, difference)
      }
      else{
      console.log(fisrtData , secondData , difference)
        return differenceInTime(fisrtData , secondData , difference)
      }
    }
  },
};
</script>
